export const handleKeyPressSpace = (event) => {
    // Prevent typing a space at the beginning
    if (event.key === ' ' && event.target.selectionStart === 0) {
      event.preventDefault();
    }
  };